// https://github.com/fronteed/iCheck/issues/62
(function (module) {
  'use strict';
  module.directive('icheck', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
      require: '?ngModel',
      link: function ($scope, element, $attrs, ngModel) {
        $scope.$applyAsync(function () {
          if (ngModel) {
            var render = ngModel.$render;
            ngModel.$render = function () {
                render();
                element.iCheck('updated');
            }
          }
          element.on('ifCreated', function () {
            if ($attrs['icheck']) {
                element.parent().addClass('icheck_' + $attrs['icheck']);
            }
          }).iCheck({
            radioClass: 'iradio_minimal-grey',
            checkboxClass: 'icheckbox_minimal-grey'
          }).on('ifChanged', function (event) {
            if ($(element).attr('type') === 'checkbox') {
              element.triggerHandler('click');
              element.triggerHandler('change');
            }
            else if ($(element).attr('type') === 'radio') {
              if ($(element).context.checked) {
                element.triggerHandler('click');
              }
            }
            $scope.$apply(function () {
                event.isChecked = element[0].checked;
            });
          });
        });
      }
    };
  }])
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/directives/icheck.directive.js